<div class="content-header">
    <div class="container-fluid">
<!-- <div class="row mb-2">
    <div class="col-sm-6">
        <h1 class="m-0 text-dark">Dashboard</h1>
    </div> -->
            <!-- /.col -->


    <!-- <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">المستكشف الجغرافي</a></li>
            <li class="breadcrumb-item active">Dashboard</li>
        </ol>
    </div> -->
            <!-- /.col -->
            <!-- <a href="geo-portal" class="btn btn-primary">المستكشف الجغرافي</a> -->

 <!-- </div> -->

        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-purple">
                    <div class="inner">
                        <h3>967</h3>

                        <p>العدد الكلي للمخططات</p>
                    </div>
                    <!-- <div class="icon">
                        <i class="ion ion-ios-analytics"></i>
                    </div> -->
                    <div  style="float:right"> 
                       
                        <h4>100</h4>  
                    </div>
                    <p  class="small-box-footer"
                        >الذي تم الانتهاء منه <i class="fas fa-arrow-circle-right"></i
                    ></p>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-teal">
                    <div class="inner">
                        <h3>258619</h3>

                        <p>العدد الكلي لقطع الأراضي</p>
                    </div>
                    <!-- <div class="icon">
                        <i class="ion ion-ios-analytics"></i>
                    </div> -->
                    <div  style="float:right">
                       
                        <h4>10000</h4>  
                    </div>
                    <p  class="small-box-footer"
                        >الذي تم الانتهاء منه <i class="fas fa-arrow-circle-right"></i
                    ></p>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-purple">
                    <div class="inner">
                        <h3>100</h3>

                        <p>العدد الكلي للأحياء</p>
                    </div>
                    <!-- <div class="icon">
                        <i class="ion ion-ios-analytics"></i>
                    </div> -->
                    <div  style="float:right">
                       
                        <h4>5</h4>  
                    </div>
                    <p  class="small-box-footer"
                        >الذي تم الانتهاء منه <i class="fas fa-arrow-circle-right"></i
                    ></p>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-teal">
                    <div class="inner">
                        <h3>2000</h3>

                        <p>العدد الكلي للطرق</p>
                    </div>
                    <!-- <div class="icon">
                        <i class="ion ion-ios-analytics"></i>
                    </div> -->
                    <div  style="float:right">
                       
                        <h4>500</h4>  
                    </div>
                    <p  class="small-box-footer"
                        >الذي تم الانتهاء منه <i class="fas fa-arrow-circle-right"></i
                    ></p>
                </div>
            </div>
            <!-- ./col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- Main row -->
</section>
<!-- /.content -->
